'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const themeTokens = ['bodytextDefaultNone', 'headersSemibigNone', 'headersMediumNone'];
const translationKeys = ['returnsCsrSignInError401', 'returnsCsrSignInError500', 'returnsCsrSignInTitle', 'returnsCsrSignInDetails', 'returnsCsrSignInOrderPlaceholder', 'returnsCsrSignInPrimaryButton'];

exports.themeTokens = themeTokens;
exports.translationKeys = translationKeys;
